import PostAdd from "./post-add";

export default PostAdd;